import { Box, Button, CircularProgress, Grid, Typography } from "@mui/material";
import BreadCrumbs from "../../components/Breadcrumbs";
import ShopImg from "../../assets/images/user-guide/shop.png";
import InvoicesImg from "../../assets/images/user-guide/my_invoices.png";
import DashboardImg from "../../assets/images/user-guide/dashboard.png";

import MyRequestsImg from "../../assets/images/user-guide/my_requests.png";

import AdditionalImg from "../../assets/images/user-guide/additional_service.png";
import BookingImg from "../../assets/images/user-guide/my_booking.png";
import QuotesImg from "../../assets/images/user-guide/quotes.png";

import CustomerSupportImg from "../../assets/images/user-guide/customer_support.png";
import DiscountRequestImg from "../../assets/images/user-guide/discount_request.png";
import SettingsImg from "../../assets/images/user-guide/settings.png";
import TicketsImg from "../../assets/images/user-guide/ticket.png";



import DownloadIcon from "@mui/icons-material/Download";
import StyledTitleDot from "../../components/common/StyledTitleDot";
import AdditionalServicesPDF from "../../assets/pdfs/user-guide/additional_service.pdf";
import QuotesPDF from "../../assets/pdfs/user-guide/quotes.pdf";
import MyRequestsPDF from "../../assets/pdfs/user-guide/my_requests.pdf";
import MyBookingsPDF from "../../assets/pdfs/user-guide/my_bookings.pdf";
import InvoicesPDF from "../../assets/pdfs/user-guide/my_invoices.pdf";
import DashboardPDF from "../../assets/pdfs/user-guide/dashboard.pdf";
import ShopPDF from "../../assets/pdfs/user-guide/shop.pdf";

import CustomerSupportPDF from "../../assets/pdfs/user-guide/customer_support.pdf";
import DiscountRequestPDF from "../../assets/pdfs/user-guide/discount_request.pdf";
import SettingsPDF from "../../assets/pdfs/user-guide/settings.pdf";
import TicketsPDF from "../../assets/pdfs/user-guide/tickets.pdf";

import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";

export default function UserGuide() {
  const lightMode = useSelector((state) => state.mode.lightMode); // Redux state'inden lightMode değerini çekin
  const { t } = useTranslation();

  const initGuideItems = useMemo(
    () => [
    {
      id: 6,
      title: t("dashboard"),
      pdfUrl: DashboardPDF,
      imgUrl: DashboardImg,
    },
    {
      id: 2,
      title: t("myRequests"),
      pdfUrl: MyRequestsPDF,
      imgUrl: MyRequestsImg,
    },
    {
      id: 3,
      title: t("myBookings"),
      pdfUrl: MyBookingsPDF,
      imgUrl: BookingImg,
    },
    {
      id: 4,
      title: t("myInvoices"),
      pdfUrl: InvoicesPDF,
      imgUrl: InvoicesImg,
    },
    /*    {
         id: 5,
         title: t("myCommissions"),
         pdfUrl: CommissionsPDF,
         imgUrl: CommissionsImg,
       }, */
    {
      id: 1,
      title: t("additionalServices"),
      pdfUrl: AdditionalServicesPDF,
      imgUrl: AdditionalImg,
    },

    {
      id: 7,
      title: t("shop"),
      pdfUrl: ShopPDF,
      imgUrl: ShopImg,
    },
    {
      id: 8,
      title: t("quotes"),
      pdfUrl: QuotesPDF,
      imgUrl: QuotesImg,
    },
    {
      id: 9,
      title: t("customerSupport"),
      pdfUrl: CustomerSupportPDF,
      imgUrl: CustomerSupportImg,
    },
    {
      id: 10,
      title: t("discountRequest"),
      pdfUrl: DiscountRequestPDF,
      imgUrl: DiscountRequestImg,
    },
    {
      id: 11,
      title: t("settings"),
      pdfUrl: SettingsPDF,
      imgUrl: SettingsImg,
    },
    {
      id: 12,
      title: t("tickets"),
      pdfUrl: TicketsPDF,
      imgUrl: TicketsImg,
    },
    ],
    [t]
  );

  const profile = useSelector((state) => state?.profile?.profile); // Redux state'inden lightMode değerini çekin
  const [guideItems, setGuideItems] = useState();

  useEffect(() => {
    // if (profile?.account_type !== "main_branch") { main branch ise ve inst değil ise göster
    if (
      profile?.account_type !== "main_branch" ||
      profile?.agency_type === "Institution"
    ) {
      let newGuideItems = initGuideItems?.filter((item) => {
        return item?.id !== 5;
      });
      setGuideItems(newGuideItems);
    } else {
      setGuideItems(initGuideItems);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile, t]);
  return (
    <>
      <Typography textTransform={"capitalize"} className="title" variant="h4">
        {t("userGuide")}
        <StyledTitleDot />
      </Typography>
      <BreadCrumbs routs={[t("userGuide")]} />
      {!profile ? (
        <CircularProgress
          sx={{
            position: "absolute",
            top: "calc(50% - 20px)",
            left: "calc(50% - 20px)",
          }}
        />
      ) : (
        <Box>
          {/*     <Typography sx={{ fontSize: "27px", marginBottom: "1rem" }}>
            Videos
          </Typography> */}
          <Box sx={{ borderTop: "1px solid #00000017", paddingTop: "2rem" }}>
            <Grid container spacing={3}>
              {guideItems?.map((item, idx) => {
                return (
                  <Grid
                    sx={{
                      filter: "drop-shadow(0px 3px 6px #00000029)",
                      cursor: "pointer",
                      "&:hover": {
                        ".play-arrow-icon": {
                          color: "#d9d9d9",
                          filter: "drop-shadow(5px 5px 13px #000000)",
                          transition: "all .4s",
                        },
                      },
                    }}
                    key={item.id}
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                  >
                    <Link
                      to={item?.pdfUrl}
                      target="_blank"
                      style={{
                        position: "relative",
                        display: "block",
                        borderRadius: "1rem",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        style={{
                          width: "100%",
                          height: "auto",
                          display: "block",
                        }}
                        src={item?.imgUrl}
                        alt="user-guide"
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: "0",
                          left: "0",
                          width: "100%",
                          zIndex: "0",
                          padding: "1rem",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          "&::before": {
                            content: '""',
                            backgroundColor: lightMode ? "#ffffff" : "#292929",
                            opacity: ".8",
                            top: "0",
                            left: "0",
                            width: "100%",
                            height: "100%",
                            position: "absolute",
                            zIndex: "-1",
                          },
                        }}
                      >
                        <Typography
                          variant="body1"
                          fontWeight={500}
                          sx={{ color: lightMode ? "#444444" : "#fff" }}
                        >
                          {item.title}
                        </Typography>
                        <Button
                          href={item?.pdfUrl}
                          target="_blank"
                          sx={{
                            fontSize: "14px",
                            color: "#ffffff",
                            borderRadius: "60px",
                            maxHeight: "30px",
                          }}
                          variant="contained"
                          color="primary"
                        >
                          Pdf{" "}
                          <DownloadIcon
                            sx={{
                              fontSize: "14px",
                              marginLeft: ".25rem",
                              color: "#ffffff",
                            }}
                          />
                        </Button>
                      </Box>
                      {/* <PlayArrowIcon
                    className="play-arrow-icon"
                    sx={{
                      position: "absolute",
                      top: "calc(50% - 2rem)",
                      left: "calc(50% - 2rem)",
                      color: "#ffffff",
                      fontSize: "4rem",
                      cursor: "pointer",
                      transition: "all .4s",
                    }}
                  /> */}
                    </Link>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Box>
      )}
    </>
  );
}
